export default {
	text: {
		manualBestlistsTitle: 'Manual Bestlist',
		manualBestlistTitle: 'Manual Bestlist',
		headerManualBestlistName: 'Name',
		manualBestlistsLoading: 'Loading bestlists',
		newManualBestlist: 'New bestlist',
		updateManualBestlistTitle: 'Change bestlist',
		manualBestlistCode: 'Code',
		newManualBestlistTitle: 'New bestlist',
		performancesTitle: 'Performance',
		manualBestlistPerformanceStatusLabel: 'Status',
		manualbestlistperformancestatus: {
			official: 'Official',
			inofficial: 'Inofficial',
		},
	},
};
